export const declarationsEs = {
  title: 'Declaraciones y alérgenos',
  subtitle:
    'Propuestas multilingües y versionadas desde recetas aprobadas con revisión jurídica controlada.',
  help: 'Abrir ayuda sobre declaraciones, catálogo y aprobaciones',
  empty: 'Ninguna versión coincide con los filtros.',
  pagination: 'Página {{page}} de {{pages}} · {{total}} versiones',
  actions: {
    catalog: 'Catálogo técnico',
    generate: 'Generar propuesta',
    newTerm: 'Entrada de catálogo',
    submit: 'Enviar a revisión',
    review: 'Finalizar revisión',
    approve: 'Aprobar',
    publish: 'Publicar',
    archive: 'Archivar',
    copy: 'Nueva versión',
    override: 'Modificar con motivo',
    confirm: 'Confirmar',
    history: 'Versiones',
  },
  filters: {
    search: 'Buscar número, producto, mercado o término',
    allStatuses: 'Todos los estados',
    allTypes: 'Todos los tipos',
  },
  statuses: {
    DRAFT: 'Borrador',
    VALIDATION_ERROR: 'Error de validación',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobada',
    PUBLISHED: 'Publicada',
    SUPERSEDED: 'Sustituida',
    ARCHIVED: 'Archivada',
  },
  catalogStatuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobada',
    SUPERSEDED: 'Sustituida',
    ARCHIVED: 'Archivada',
  },
  allergenStatuses: {
    CONTAINS: 'Contiene',
    MAY_CONTAIN: 'Puede contener',
    DOES_NOT_CONTAIN: 'No contiene',
    UNKNOWN: 'Desconocido',
  },
  issueSeverity: { ERROR: 'Error', WARNING: 'Advertencia' },
  types: {
    INGREDIENT: 'Ingrediente',
    ALLERGEN: 'Alérgeno',
    ADDITIVE: 'Aditivo',
    FUNCTION_CLASS: 'Clase funcional',
    ORIGIN_STATEMENT: 'Indicación de origen',
    COLLECTIVE_DESIGNATION: 'Denominación colectiva',
    WARNING: 'Advertencia',
    CLAIM: 'Declaración',
    PRODUCT_DESIGNATION: 'Denominación legal/de producto',
    QUID_RULE: 'Regla QUID',
  },
  columns: {
    number: 'Número',
    product: 'Producto',
    market: 'Mercado',
    version: 'Versión',
    status: 'Estado',
    issues: 'Errores / advertencias',
    updated: 'Actualizada',
    key: 'Clave',
    type: 'Tipo',
    name: 'Denominación',
    validity: 'Validez',
    path: 'Fuente / ruta',
    weight: 'Peso relevante',
    percentage: 'Proporción',
    flags: 'Indicadores',
    field: 'Campo',
    recipe: 'Receta',
  },
  fields: {
    key: 'Clave estable',
    type: 'Tipo técnico',
    code: 'Código / número E',
    metadata: 'Metadatos configurables (JSON)',
    validFrom: 'Válida desde',
    validTo: 'Válida hasta',
    changeReason: 'Motivo del cambio',
    name: 'Denominación',
    synonyms: 'Sinónimos separados por comas',
    description: 'Descripción',
    reason: 'Nota de revisión o decisión',
    recipe: 'Versión de receta aprobada',
    number: 'Número de declaración (opcional)',
    market: 'Clave de mercado/reglas',
    ingredients: 'Lista de ingredientes',
    allergens: 'Indicación de alérgenos',
    additives: 'Aditivos',
    warnings: 'Advertencias y origen',
    productDesignation: 'Denominación legal/de producto',
    ingredientText: 'Lista de ingredientes',
    allergenText: 'Indicación de alérgenos',
    additiveText: 'Texto de aditivos',
    warningText: 'Advertencias y origen',
    overrideReason: 'Motivo de la desviación manual',
    warningAcknowledgement: 'Aceptación motivada de todas las advertencias restantes',
  },
  catalog: {
    title: 'Catálogo de declaración configurable',
    subtitle:
      'Ingredientes, alérgenos, aditivos, clases, reglas y términos lingüísticos versionados.',
    empty: 'No se encontró ninguna versión.',
    createTitle: 'Crear entrada',
    editTitle: 'Editar versión v{{version}}',
    editorHelp:
      'Los números de metadatos se guardan como cadenas decimales. Todos los idiomas deben estar completos antes de revisar.',
    historyTitle: 'Historial de versiones: {{key}}',
    historyDescription:
      'Los términos aprobados son inmutables; los cambios crean una nueva versión.',
  },
  generate: {
    title: 'Generar propuesta de declaración',
    description:
      'El motor resuelve de forma reproducible la BOM, subrecetas e ingredientes compuestos aprobados.',
    legalWarning:
      'No es una aprobación jurídica automática. Se requiere revisión experta independiente y publicación explícita.',
  },
  detail: {
    subtitle: 'Versión {{version}} · Mercado {{market}} · Fuente {{recipe}} v{{recipeVersion}}',
  },
  legal: {
    title: 'Se requiere revisión técnica y jurídica',
    description:
      'La propuesta, QUID, declaraciones, advertencias y traducciones deben ser revisadas por personal cualificado antes de un uso jurídicamente vinculante.',
  },
  summary: {
    status: 'Estado del flujo',
    ingredients: 'Partidas de ingredientes',
    allergens: 'Hallazgos de alérgenos',
    errors: 'Errores de validación',
    warnings: 'Advertencias',
  },
  tabs: {
    preview: 'Vista por idioma',
    comparison: 'Comparar idiomas',
    sources: 'Fuentes e instantánea',
    validation: 'Validación',
    history: 'Historial',
  },
  sections: {
    ingredients: 'Ingredientes ordenados por peso',
    allergens: 'Alérgenos derivados',
    additives: 'Aditivos y clases funcionales',
    sourceSnapshot: 'Evidencia de origen inmutable',
    validation: 'Validación y calidad de datos',
    history: 'Revisiones de declaración',
  },
  preview: {
    ingredientText: 'Texto efectivo que debe aprobarse para este idioma.',
    sorting: 'El orden y los porcentajes se calcularon exactamente desde el peso declarativo.',
    unknownWarning: '«Desconocido» nunca se interpreta como «no contiene».',
  },
  comparison: {
    title: 'Comparar todos los idiomas admitidos',
    description: 'Los valores amarillos son desviaciones motivadas del texto automático.',
    automatic: 'Mostrar texto calculado automáticamente',
  },
  sources: {
    description: 'Las versiones aprobadas concretas y el hash permiten reproducir el cálculo.',
    approvedAt: 'Receta aprobada el',
    profiles: 'Versiones de perfil de materia',
    catalogVersions: 'Versiones de catálogo',
    materialSources: 'Fuentes de materia',
  },
  validation: {
    description:
      'Los errores bloquean la revisión. Las advertencias deben evaluarse y aceptarse antes de aprobar.',
  },
  history: {
    description: 'Las versiones publicadas permanecen inmutables como instantáneas completas.',
  },
  states: {
    noAllergens: 'No hay hallazgos de alérgenos en las fuentes aprobadas.',
    noAdditives: 'No hay aditivos en las fuentes aprobadas.',
    noIssues: 'No hay errores ni advertencias de calidad.',
    notFound: 'No se encontró la versión de declaración.',
  },
  override: {
    title: 'Documentar desviaciones manuales',
    description:
      'Los textos automáticos permanecen en la instantánea. Cada cambio se registra con su motivo técnico.',
  },
  publish: {
    confirmation:
      'La confirmación publica exactamente esta instantánea aprobada e inmutable. No sustituye asesoramiento jurídico externo.',
  },
  actionDialog: {
    APPROVE: {
      title: 'Aprobar declaración',
      description:
        'La aprobación independiente congela la versión. Las advertencias restantes exigen aceptación trazable.',
    },
    COPY: {
      title: 'Crear versión de catálogo',
      description: 'El contenido se copia a un nuevo borrador editable.',
    },
    ARCHIVE: {
      title: 'Archivar versión',
      description: 'La versión sigue siendo auditable, pero deja de estar activa.',
    },
    REVIEW: {
      title: 'Finalizar revisión técnica',
      description:
        'Documentar la revisión independiente de fuentes, cálculo, idiomas y advertencias.',
    },
    PUBLISH: {
      title: 'Publicar explícitamente la declaración',
      description: 'La publicación es un paso jurídicamente relevante separado de la aprobación.',
    },
  },
  messages: {
    generated: 'Propuesta generada de forma reproducible.',
    saved: 'Versión de catálogo guardada.',
    overrideSaved: 'Desviaciones manuales registradas.',
    submitted: 'Declaración enviada a revisión independiente.',
    workflow: 'Flujo actualizado con pista de auditoría.',
  },
} as const;
